module.exports = vendor_0c035fc562fc7d952b90;